const menuToggle = document.getElementById('menuToggle');
  const menuOverlay = document.getElementById('menuOverlay');

  function setMenu(open){
    menuToggle.classList.toggle('is-open', open);
    menuOverlay.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', open);
    menuToggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
  }
  menuToggle.addEventListener('click', () => setMenu(!menuOverlay.classList.contains('is-open')));
  menuOverlay.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  const navLinks = document.querySelectorAll('.nav-link');
  const uniqueHrefs = [...new Set([...navLinks].map(a => a.getAttribute('href')))];
  const sections = uniqueHrefs.map(href => document.querySelector(href)).filter(Boolean);
  if ('IntersectionObserver' in window && sections.length){
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting){
          const href = '#' + entry.target.id;
          navLinks.forEach(a => a.classList.toggle('is-active', a.getAttribute('href') === href));
        }
      });
    }, {rootMargin:'-45% 0px -45% 0px'});
    sections.forEach(s => observer.observe(s));
  }

  /* 動画：画面内に入って初めて読み込み・再生（データ通信量・バッテリー節約） */
  const lazyVideos = document.querySelectorAll('.lazy-video');
  if ('IntersectionObserver' in window && lazyVideos.length){
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting){
          if (!video.src && video.dataset.src){
            video.src = video.dataset.src;
          }
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, {rootMargin:'200px 0px'});
    lazyVideos.forEach(v => videoObserver.observe(v));
  } else {
    lazyVideos.forEach(v => { v.src = v.dataset.src; v.play().catch(() => {}); });
  }

  /* 下部固定CTA：ヒーロー内のボタンが画面外に出たら表示（同じボタンの二重表示を防止） */
  const heroBtn = document.querySelector('.hero-btn');
  const stickyCta = document.querySelector('.sticky-cta');
  if (heroBtn && stickyCta && 'IntersectionObserver' in window){
    const ctaObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      });
    });
    ctaObserver.observe(heroBtn);
  }

  /* プライバシーポリシー：ページ内オーバーレイ */
  const privacyOverlay = document.getElementById('privacyOverlay');
  let privacyTrigger = null;
  function setPrivacy(open){
    privacyOverlay.classList.toggle('is-open', open);
    document.body.style.overflow = (open || document.getElementById('contactOverlay').classList.contains('is-open')) ? 'hidden' : '';
    if (open){ privacyOverlay.scrollTop = 0; document.getElementById('privacyClose').focus(); }
    else if (privacyTrigger){ privacyTrigger.focus(); }
  }
  document.querySelectorAll('.js-privacy-open').forEach(a => a.addEventListener('click', e => {
    e.preventDefault(); privacyTrigger = a; setPrivacy(true);
  }));
  document.getElementById('privacyClose').addEventListener('click', () => setPrivacy(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && privacyOverlay.classList.contains('is-open')) setPrivacy(false); });

  /* お問い合わせフォーム：ページ内オーバーレイ（入力→確認→完了） */
  const contactOverlay = document.getElementById('contactOverlay');
  const cfSteps = ['cfStep1','cfStep2','cfStep3'];
  let contactTrigger = null;
  function cfShow(n){
    cfSteps.forEach((id,i) => document.getElementById(id).hidden = (i !== n));
    ['cfS1','cfS2','cfS3'].forEach((id,i) => document.getElementById(id).classList.toggle('is-current', i === n));
    contactOverlay.scrollTop = 0;
  }
  function setContact(open){
    contactOverlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open){ cfShow(0); contactOverlay.scrollTop = 0; document.getElementById('contactClose').focus(); }
    else if (contactTrigger){ contactTrigger.focus(); }
  }
  document.querySelectorAll('.js-contact-open').forEach(a => a.addEventListener('click', e => {
    e.preventDefault(); contactTrigger = a; setContact(true);
  }));
  document.getElementById('contactClose').addEventListener('click', () => setContact(false));
  document.getElementById('cfDone').addEventListener('click', () => setContact(false));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && contactOverlay.classList.contains('is-open') && !privacyOverlay.classList.contains('is-open')) setContact(false);
  });

  const cfForm = document.getElementById('contactForm');
  const val = id => document.getElementById(id).value.trim();
  function cfClearErrors(){ cfForm.querySelectorAll('.cf-error').forEach(e => e.remove()); }
  function cfErr(id, msg){
    const el = document.getElementById(id);
    const p = document.createElement('p'); p.className = 'cf-error'; p.textContent = msg;
    el.closest('.cf-field').appendChild(p);
    return el;
  }
  function cfValidate(){
    cfClearErrors();
    let first = null;
    const fail = (id,msg) => { const el = cfErr(id,msg); if (!first) first = el; };
    if (!val('cfSubject')) fail('cfSubject','お問い合わせ件名を選択してください。');
    if (!val('cfName1') || !val('cfName2')) fail('cfName1','お名前（姓・名）を入力してください。');
    const kana = /^[ァ-ヶー　\s]+$/;
    if (!kana.test(val('cfKana1')) || !kana.test(val('cfKana2'))) fail('cfKana1','お名前（カタカナ）を全角カタカナで入力してください。');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('cfMail'))) fail('cfMail','メールアドレスを正しく入力してください。');
    else if (val('cfMail') !== val('cfMail2')) fail('cfMail2','確認用のメールアドレスが一致しません。');
    if (!/^[0-9０-９+\-ー－\s()（）]{8,}$/.test(val('cfTel'))) fail('cfTel','電話番号を正しく入力してください。');
    if (!val('cfText')) fail('cfText','お問い合わせ内容を入力してください。');
    if (first) first.focus();
    return !first;
  }
  cfForm.addEventListener('submit', e => {
    e.preventDefault();
    if (!cfValidate()) return;
    const rows = [
      ['お問い合わせ件名', val('cfSubject')],
      ['お名前', val('cfName1') + ' ' + val('cfName2')],
      ['お名前（カタカナ）', val('cfKana1') + ' ' + val('cfKana2')],
      ['メールアドレス', val('cfMail')],
      ['電話番号', val('cfTel')],
      ['お問い合わせ内容', val('cfText')]
    ];
    const dl = document.getElementById('cfConfirm');
    dl.textContent = '';
    rows.forEach(([k,v]) => {
      const d = document.createElement('div');
      const dt = document.createElement('dt'); dt.textContent = k;
      const dd = document.createElement('dd'); dd.textContent = v;
      d.append(dt,dd); dl.appendChild(d);
    });
    document.getElementById('cfAlert').hidden = true;
    cfShow(1);
  });
  document.getElementById('cfBack').addEventListener('click', () => cfShow(0));
  document.getElementById('cfSend').addEventListener('click', () => {
    const btn = document.getElementById('cfSend');
    // Shopify 標準フォームへ送信。本文(contact[body])に全項目をまとめて格納してから submit する。
    const bodyEl = document.getElementById('cfBody');
    if (bodyEl){
      bodyEl.value = [
        '【お問い合わせ件名】' + val('cfSubject'),
        '【お名前】' + val('cfName1') + ' ' + val('cfName2'),
        '【お名前（カタカナ）】' + val('cfKana1') + ' ' + val('cfKana2'),
        '【メールアドレス】' + val('cfMail'),
        '【電話番号】' + val('cfTel'),
        '【お問い合わせ内容】', val('cfText')
      ].join('\n');
    }
    btn.disabled = true;
    // ページ遷移を伴う通常の POST。成功後 Shopify が同ページへ戻し、完了画面を表示する。
    cfForm.submit();
  });

  /* 送信完了の検出：Shopify は送信成功後に ?contact_posted=true 付きで戻す。
     セクション側のマーカー(#cfPosted)か、URL パラメータで判定して完了画面を表示する。 */
  (function handleContactPosted(){
    const posted = document.getElementById('cfPosted')
      || (/[?&]contact_posted=true/.test(location.search) ? true : null);
    if (!posted) return;
    // オーバーレイを開いて完了画面(step3)へ
    setContact(true);
    cfShow(2);
    // URL のクエリを掃除（リロードでの二重表示を防ぐ）
    if (history.replaceState){
      history.replaceState(null, '', location.pathname + location.hash);
    }
  })();

  /* サーバー側エラーがある場合は入力画面(step1)を開いて見せる */
  (function handleContactError(){
    if (document.getElementById('cfServerError')){
      setContact(true);
      cfShow(0);
    }
  })();

